import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './advanceMonitor.css';

const AdvanceMonitor = (props) => {

    const [percent, setPercent] = useState(0); 
    const [total, setTotal] = useState(0); 
    const [queued, setQueued] = useState(0); 
    const [pending, setPending] = useState(0);
    const [intervalId, setIntervalId] = useState(0);
    const [errorGettingAdvance, setErrorGettingAdvance] = useState(false);

    let lastInterval=0;

    useEffect(() => {
        getAdvance(); //first time
        startMonitor();

        return () => { //clear Interval when unmount this component
           clearInterval(lastInterval);
        }

    }, []);

    useEffect(() => {
        if(Number(percent)===100){
            startMonitor();
        }
    }, [percent]);


    const startMonitor=()=>{
        if (intervalId) {
            clearInterval(intervalId);
            setIntervalId(0);
            return;
        }
    
        const newIntervalId = setInterval(() => {
            getAdvance();
        }, 30000);
        setIntervalId(newIntervalId);
        lastInterval=newIntervalId;
    }

    const getAdvance=()=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/campaignAdvance`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: {campaignId:props.campaignId}
        };
        axios(options).then(response => {
            setErrorGettingAdvance(false);
            let advance=response.data.advance;
            if (!(advance.total === 0 && advance.queued === 0 && advance.pending===0)){
                let percent=Number(((advance.queued * 100) / advance.total).toFixed(0));
                let total=advance.total;
                let queued=advance.queued;
                let pending=advance.pending;

                setPercent(percent);
                setTotal(total);
                setQueued(queued);
                setPending(pending);
            } else {
                setPercent(0);
                setTotal(0);
                setQueued(0);
                setPending(0);
            }
        }).catch((error)=> {
            setErrorGettingAdvance(true);
            console.log("Error:", error.message); 
        });
    }

    

    return (
        <div className="advanceMonitor" tooltip={'Total:'+total+", discados:"+queued+', pendientes:'+pending} tooltip_position='left'>  
            <div className="progressbar" style={props.width?{"width":props.width}:null}>
                <div className={errorGettingAdvance?'ind error':'ind'} style={{"width":percent+"%"}}></div>
            </div>
            <div className="percentage">{percent}%</div>
        </div>
    );
    
}

export default AdvanceMonitor;